"use client";
import React from "react";
import ActiveDatesSection from "@/components/coupon/activeDatesSection";
import SaveAmountOffOrder from "@/components/coupon/amount-off-order/saveCoupon";
import BreadCrumbs from "@/components/coupon/breadCrumbs";
import DiscountMethodSection from "@/components/coupon/discountMethodSection";
import DiscountValueSection from "@/components/coupon/discountValueSection";
import MinimumPurchaseRequirements from "@/components/coupon/minimumPurchaseRequirements";

const AmountOffOrderPage = () => {
  return (
    <div className="coupon-page space-y-6">
      <BreadCrumbs page="Amount Off Order" />
      <DiscountMethodSection currentPage="amountOffOrder" />
      <DiscountValueSection currentPage="amountOffOrder" />
      <div className="grid w-full grid-cols-[repeat(auto-fit,minmax(min(250px,100%),1fr))] gap-5">
        <MinimumPurchaseRequirements currentPage="amountOffOrder" />
        <ActiveDatesSection currentPage="amountOffOrder" />
      </div>
      <SaveAmountOffOrder currentPage="amountOffOrder" />
    </div>
  );
};

export default AmountOffOrderPage;
